import { REACT_APP_API_BASE } from '../config';

export const createMapService = (fetch) => ({
    /**
     * Fetch units for a specific district type
     * @param {string} type - The district type
     * @returns {Promise<Array>} - Array of units
     */
    fetchPins: async (type) => {
        const res = await fetch(`${REACT_APP_API_BASE}/salesdistrict/units/${type}`);
        return res.json();
    },

    /**
     * Fetch GeoJSON data for a specific file
     * @param {string} file - The file path
     * @returns {Promise<Object>} - GeoJSON data
     */
    fetchGeoJSON: async (file) => {
        // Use regular fetch for public GeoJSON files
        const response = await window.fetch(file);
        return response.json();
    },

    /**
     * Create a new district
     * @param {string} type - The district type
     * @param {string} scenarioId - Optional scenario ID
     * @returns {Promise<Object>} - Created district data
     */
    createDistrict: async (type, scenarioId) => {
        const res = await fetch(`${REACT_APP_API_BASE}/salesdistrict/create/${type}${scenarioId ? `/${scenarioId}` : ''}`);
        return res.json();
    },

    /**
     * Fetch an existing district
     * @param {string} id - The district ID
     * @returns {Promise<Object>} - District data
     */
    fetchDistrict: async (id) => {
        const res = await fetch(`${REACT_APP_API_BASE}/salesdistrict/edit/${id}`);
        const district = await res.json();
        return {
            ...district,
            homeMarkerGeoJson: district.homeMarkerGeoJson && district.homeMarkerGeoJson !== '' ? JSON.parse(district.homeMarkerGeoJson) : [],
            spatialGeoJson: JSON.parse(district.spatialGeoJson)
        };
    },

    /**
     * Save a district
     * @param {Object} districtData - The district data to save
     * @param {boolean} isEdit - Whether this is an edit operation
     * @returns {Promise<Object>} - Saved district data
     */
    saveDistrict: async (districtData, isEdit) => {
        const path = isEdit 
            ? `${REACT_APP_API_BASE}/salesdistrict/edit/${isEdit}` 
            : `${REACT_APP_API_BASE}/salesdistrict/create/${districtData.type}`;

        const rawResponse = await fetch(path, {
            method: isEdit ? 'PATCH' : 'POST',
            body: JSON.stringify(districtData)
        });

        if (!rawResponse.ok) {
            throw new Error('Failed to save district');
        }

        return rawResponse.json();
    },

    /**
     * Fetch spatial information for districts
     * @param {string} type - The district type
     * @param {string} scenarioId - Optional scenario ID
     * @returns {Promise<Array>} - Array of district spatial data
     */
    fetchSpatialInfo: async (type, scenarioId) => {
        const res = await fetch(`${REACT_APP_API_BASE}/salesdistrict/spatialinfo/${type}${scenarioId ? `/${scenarioId}` : ''}`);
        return res.json();
    }
}); 